import * as React from 'react';

import { StyleSheet, color, css } from '@coursera/coursera-ui';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isDisabled: boolean;
  label: string;
  type: 'clearAll' | 'update';
};

const styles = StyleSheet.create({
  button: {
    borderColor: 'transparent',
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '24px',
    minHeight: 36,
    padding: '0.5rem 2.2rem',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  clearAllDisabled: {
    color: color.bgGrayThemeMid,
    cursor: 'not-allowed',
  },
  clearAllActive: {
    color: color.primary,
  },
  clearAll: {
    backgroundColor: color.white,
  },
  updateDisabled: {
    backgroundColor: color.bgGrayThemeMid,
    cursor: 'not-allowed',
  },
  updateActive: {
    backgroundColor: color.primary,
  },
  update: {
    color: color.white,
  },
});

const BUTTON_STATE = {
  clearAllDisabled: 'clearAllDisabled',
  clearAllActive: 'clearAllActive',
  updateDisabled: 'updateDisabled',
  updateActive: 'updateActive',
};

const BUTTON_TYPE = {
  clearAll: 'clearAll',
  update: 'update',
};

const determineType = (isDisabled: boolean, type: (typeof BUTTON_TYPE)[keyof typeof BUTTON_TYPE]) => {
  if (isDisabled && type === BUTTON_TYPE.clearAll) {
    return BUTTON_STATE.clearAllDisabled;
  } else if (type === BUTTON_TYPE.clearAll) {
    return BUTTON_STATE.clearAllActive;
  } else if (isDisabled) {
    return BUTTON_STATE.updateDisabled;
  } else {
    return BUTTON_STATE.updateActive;
  }
};

const FilterDrawerButton: React.FC<Props> = ({ onClick, isDisabled, label, type }) => {
  const buttonState = determineType(isDisabled, type);

  return (
    <button
      type="button"
      onClick={(event) => !isDisabled && onClick && onClick(event)}
      // @ts-expect-error FIXME result of fixing typing on coursera-ui aphrodite exports in PR#45351
      {...css(styles.button, styles[type], styles[buttonState])}
      data-testid={`${type}-filter-drawer`}
    >
      {label}
    </button>
  );
};

export default FilterDrawerButton;
